/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

import {Breadcrumb, Result} from "antd";
import {Link} from "react-router-dom";

export default function Error404View(props: any) {
    return (
        <>
            <Breadcrumb style={{paddingTop: 6, paddingBottom: 6}}>
                <Breadcrumb.Item><Link to="/">Home</Link></Breadcrumb.Item>
                <Breadcrumb.Item>Unbekannt</Breadcrumb.Item>
            </Breadcrumb>

            <Result
                status="404"
                title="404 - Not Found!"
                subTitle="Die gesuchte Seite gibt es leider nicht."
            />
        </>
    )
}